// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-col.hide {\n  display: none;\n}\n.case-menu-btn,\n.subject-menu-btn {\n  float: right;\n}\n.row-header {\n  border-bottom: 1px solid lightgrey;\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
